<div class="acc-surveys-by-topic-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="surveysByTopic()"></grid-content>
</div>